import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionHeader } from '../components/SectionHeader';
import { ServiceCard } from '../components/ServiceCard';
import { services } from '../data/services';
import { Button } from '../components/Button';
import { GlowOrb } from '../components/GlowOrb';
import { MessageCircle } from 'lucide-react';
export function Services() {
  const [filter, setFilter] = useState('all');
  const categories = [{
    id: 'all',
    label: 'All Services'
  }, {
    id: 'energy',
    label: 'Energy & Aura'
  }, {
    id: 'mind',
    label: 'Mind & Emotion'
  }, {
    id: 'spiritual',
    label: 'Spiritual Growth'
  }, {
    id: 'premium',
    label: 'Premium Programs'
  }];
  const filteredServices = services.filter(service => {
    if (filter === 'all') return true;
    if (filter === 'premium') return service.isPremium;
    const text = (service.title + ' ' + service.shortDescription).toLowerCase();
    if (filter === 'energy') return text.includes('energy') || text.includes('aura') || text.includes('chakra');
    if (filter === 'mind') return text.includes('mind') || text.includes('emotion') || text.includes('stress') || text.includes('anxiety');
    if (filter === 'spiritual') return text.includes('spiritual') || text.includes('astrology') || text.includes('soul');
    return true;
  });
  return <div className="pb-24 relative overflow-hidden" data-id="element-908">
      {/* Header */}
      <section className="pt-32 pb-20 relative min-h-[60vh] flex items-center" data-id="element-909">
        <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{
        backgroundImage: `url(https://images.unsplash.com/photo-1518791841217-8f162f1e1131?q=80&w=2000&auto=format&fit=crop)`
      }} data-id="element-910"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-midnight via-midnight/70 to-midnight" data-id="element-911"></div>
        <GlowOrb color="primary" size="xl" position="top-0 left-0" data-id="element-912" />
        <GlowOrb color="gold" size="lg" position="bottom-0 right-0" delay={3} data-id="element-913" />
        <div className="container mx-auto px-6 relative z-10" data-id="element-914">
          <SectionHeader eyebrow="Sacred Offerings" title="Our Healing Services" description="Explore our comprehensive collection of spiritual wellness services. Whether you need deep emotional release, energetic clearing, or cosmic guidance, you will find your path here." data-id="element-915" />
        </div>
      </section>

      <div className="container mx-auto px-6 relative z-10" data-id="element-916">
        {/* Filters */}
        <div className="flex flex-wrap justify-center gap-3 mb-16" data-id="element-917">
          {categories.map(cat => <button key={cat.id} onClick={() => setFilter(cat.id)} className={`px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 border ${filter === cat.id ? 'bg-gold text-midnight border-gold shadow-[0_0_15px_rgba(212,175,110,0.3)]' : 'bg-white/5 text-beige border-white/10 hover:border-gold/50 hover:text-gold'}`} data-id="element-918">
              {cat.label}
            </button>)}
        </div>

        {/* Premium Banner (shows when 'all' or 'premium' is selected) */}
        <AnimatePresence data-id="element-919">
          {(filter === 'all' || filter === 'premium') && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="mb-16" data-id="element-920">
              <div className="rounded-[2.5rem] p-1 bg-gradient-to-r from-primary via-gold to-primary" data-id="element-921">
                <div className="bg-midnight rounded-[2.4rem] p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-8 relative overflow-hidden" data-id="element-922">
                  <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{
                backgroundImage: `url(https://images.unsplash.com/photo-1543722530-d2c3201371e7?q=80&w=2000&auto=format&fit=crop)`
              }} data-id="element-923"></div>
                  <div className="absolute inset-0 bg-gradient-to-r from-midnight via-midnight/85 to-midnight/60" data-id="element-924"></div>
                  <div className="absolute inset-0 bg-star-dust opacity-30 mix-blend-screen" data-id="element-925"></div>
                  <div className="relative z-10 max-w-2xl" data-id="element-926">
                    <div className="text-gold text-xs font-bold tracking-widest uppercase mb-3" data-id="element-927">
                      Signature Offering
                    </div>
                    <h3 className="text-3xl md:text-4xl font-serif text-white mb-4" data-id="element-928">
                      Premium Healing Programs
                    </h3>
                    <p className="text-beige-muted" data-id="element-929">
                      Multi-week, intensive transformational journeys combining
                      all modalities for profound life shifts. Includes
                      unlimited support and custom rituals.
                    </p>
                  </div>
                  <div className="relative z-10 flex-shrink-0" data-id="element-930">
                    <Button href="/services/premium-healing-programs" variant="primary" size="lg" data-id="element-931">
                      Explore Programs
                    </Button>
                  </div>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>

        {/* Services Grid */}
        <motion.div layout className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-932">
          <AnimatePresence data-id="element-933">
            {filteredServices.filter(s => !s.isPremium || filter !== 'all').map((service, index) => <motion.div key={service.id} layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.3
          }} data-id="element-934">
                  <ServiceCard service={service} data-id="element-935" />
                </motion.div>)}
          </AnimatePresence>
        </motion.div>

        {/* Bottom CTA */}
        <div className="mt-32 glass p-12 md:p-20 rounded-[3rem] text-center relative overflow-hidden" data-id="element-936">
          <GlowOrb color="gold" size="md" position="top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-937" />
          <div className="relative z-10" data-id="element-938">
            <h3 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-939">
              Not sure where to start?
            </h3>
            <p className="text-beige-muted mb-10 max-w-2xl mx-auto text-lg" data-id="element-940">
              Every healing journey is unique. Connect with us on WhatsApp for a
              free consultation to identify the perfect service for your current
              energetic needs.
            </p>
            <Button href="https://wa.me/1234567890" variant="primary" size="lg" icon={<MessageCircle className="w-5 h-5" data-id="element-942" />} data-id="element-941">
              Chat on WhatsApp
            </Button>
          </div>
        </div>
      </div>
    </div>;
}